import {
  Object3D,
  Color,
  Mesh,
  MeshBasicMaterial,
  Vector3,
  DoubleSide,
  LineBasicMaterial,
  Line,
  BufferGeometry,
  SphereGeometry,
  CircleGeometry,
  BufferAttribute,
  MeshStandardMaterial,
} from "three";
import { Text } from "troika-three-text";
import Util from "./utils";
import { CommonCommand } from "../command/commonCommand";
import { setUnit, setMVisible } from "../../store/module/app";
import store from "../../store/index.js";

class MeasureUtil {
  constructor(scene, camera, manager) {
    this.scene = scene;
    this.camera = camera;
    this.manager = manager;
    this.helpSphereRadius = 0.05;
    this.helpSphereColor = "#f91c2e";
    this.helpLineColor = "#f91c2e";
    this.textColor = "#ff0000";
    this.textSize = 0.2;

    this.scale=1;
    if(this.scale<=0)
      this.scale = 1; //比例尺

    this.unit = "m"; //单位  m,cm,mm

    this.mode = 0; //0：距离测量  1：角度测量  2：标高测量

    this.allRecordVisible = true; //是否显示所有测量记录

    this.points = []; //保存点击的点   距离测量两个点，角度测量3个点，标高1个点
    this.measureRecord = []; //测量记录
    this.lines = []; //临时保存角度测量的线

    console.log(this.manager);
  }

  setCamera(camera) {
    this.camera = camera;
  }

  /**
   * 点击到mesh时把点击到的位置传递进来进行测量
   * @param {Vector3} point 世界坐标
   */
  clickMesh(point) {
    if (!point) return;
    switch (this.mode) {
      case 0:
        //if (this.points.length >= 2) this.clear();
        if (this.points.length == 0) {
          let s = this._createSphere(point);
          this.points.push(s);

          // 历史记录
          {
            const state = {
              obj: s,
            };
            const cmd = new CommonCommand(
              state,
              (state) => {
                this.scene.remove(state.obj);
                this.points = [];
              },
              (state) => {
                this.scene.add(state.obj);
                this.points.push(state.obj);
              }
            );
            this.manager.addHistory(cmd);
          }
        } else {
          let s = this._createSphere(point);
          this.points.push(s);
          this._measureDistance();
        }
        break;
      case 1:
        //if (this.points.length >= 3) this.clear();
        if (this.points.length == 0) {
          let s = this._createSphere(point);
          this.points.push(s);
        } else if (this.points.length == 1) {
          let s = this._createSphere(point);
          this.points.push(s);

          let line = this._drawLine(
            this.points[0].position,
            this.points[1].position
          );
          this.lines.push(line);
        } else {
          let s = this._createSphere(point);
          this.points.push(s);

          let line = this._drawLine(
            this.points[1].position,
            this.points[2].position
          );
          this.lines.push(line);
          this._measureAngle();
        }
        break;
      case 2:
        //if (this.points.length >= 1) this.clear();
        let s = this._createSphere(point);
        this.points.push(s);
        this._measureHeight();
        break;
    }
  }

  /**
   * 设置距离测量和标高测量的比例尺
   * @param {比例尺} s
   */
  setScale(s = 1) {


    this.scale = s;
  }

  /**
   * 设置距离测量和标高测量的单位
   * @param {*} u  可选项为 "m","cm","mm"
   */
  setUnit(u = "m", fromHistory = false) {
    if (this.unit === u) return;
    if (u === "m" || u === "cm" || u === "mm") {
      // 历史记录相关
      if (!fromHistory) {
        const state = {
          oldUnit: this.unit,
          newUnit: u,
        };
        const cmd = new CommonCommand(
          state,
          (state) => {
            this.setUnit(state.oldUnit, true);
            store.dispatch(setUnit(state.oldUnit));
          },
          (state) => {
            this.setUnit(state.newUnit, true);
            store.dispatch(setUnit(state.newUnit));
          }
        );
        this.manager.addHistory(cmd);
      }

      this.unit = u;

      for (let i = 0; i < this.measureRecord.length; i++) {
        let record = this.measureRecord[i];
        if (record.type === "distance" || record.type === "height") {
          const pos = record.text[0].position.clone();
          Util.disposeFun(record.text[0]);

          let dis = record.data;
          const str = this.getDisStr(dis);

          let text = this._createTextSprite(pos, str);
          record.text = [text];
        }

        record.distance = this._getDis(record.data);
      }

      if (this.updateMeasureRecordCB)
        this.updateMeasureRecordCB(this.getRecords());
    }
  }
  /**
   * 距离测量
   */
  _measureDistance() {
    let line = this._drawLine(this.points[0].position, this.points[1].position);

    let pos = this.points[0].position
      .clone()
      .add(this.points[1].position)
      .divideScalar(2);
    pos.y += 0.2;
    let dis =
      this.points[0].position.clone().distanceTo(this.points[1].position) *
      this.scale;

    let str = this.getDisStr(dis);

    let text = this._createTextSprite(pos, str);

    const record = {
      type: "distance",
      data: dis, // 完整距离，m
      distance: this._getDis(dis), // 距离，单位换算后的距离
      line: [line],
      text: [text],
      id: text.uuid,
      visible: true,
      name: "距离测量" + this.measureRecord.length,
      point: [this.points[0], this.points[1]],
    };
    this.measureRecord.push(record);

    if (this.updateMeasureRecordCB) {
      this.updateMeasureRecordCB(this.getRecords());
    }

    // 历史记录相关
    {
      const state = {
        line: line,
        text: text,
        record: record,
        points: [].concat(this.points),
      };
      const cmd = new CommonCommand(
        state,
        (state) => {
          this.points = [state.points[0]];
          this.scene.remove(state.points[1]);

          this.scene.remove(state.line);
          this.scene.remove(state.text);
          this.measureRecord.splice(
            this.measureRecord.indexOf(state.record),
            1
          );

          if (this.updateMeasureRecordCB) {
            this.updateMeasureRecordCB(this.getRecords());
          }
        },
        (state) => {
          this.scene.add(state.line);
          this.scene.add(state.text);
          this.points = [];
          this.measureRecord.push(state.record);
          this.scene.add(state.points[1]);

          if (this.updateMeasureRecordCB) {
            this.updateMeasureRecordCB(this.getRecords());
          }
        }
      );
      this.manager.addHistory(cmd);
    }

    this.points = [];
  }

  _getDis(dis) {
    let res = 0;
    if (this.unit === "m") {
      res = dis.toFixed(2) * 1;
    } else if (this.unit === "cm") {
      res = (dis * 100).toFixed(2) * 1;
    } else if (this.unit === "mm") {
      res = (dis * 1000).toFixed(2) * 1;
    }
    return res;
  }

  getDisStr(dis) {
    let str = "";
    if (this.unit === "m") {
      str = dis.toFixed(2).toString() + "m";
    } else if (this.unit === "cm") {
      str = (dis * 100).toFixed(2).toString() + "cm";
    } else if (this.unit === "mm") {
      str = (dis * 1000).toFixed(2).toString() + "mm";
    }
    return str;
  }

  /**
   * 角度测量
   */
  _measureAngle() {
    let dir1 = this.points[0].position.clone().sub(this.points[1].position);
    let dir2 = this.points[2].position.clone().sub(this.points[1].position);

    let res = this._drawAngleIcon(
      this.points[0].position.clone(),
      this.points[1].position.clone(),
      this.points[2].position.clone()
    );

    let dir = res.pos.clone().sub(this.points[1].position).normalize();
    let dis = res.pos.clone().distanceTo(this.points[1].position);
    let targetPos = this.points[1].position
      .clone()
      .add(dir.clone().multiplyScalar(dis + 0.2));

    let angle = dir1.angleTo(dir2);
    angle = this._deg2rad(angle); // 弧度转角度
    let text = this._createTextSprite(
      targetPos,
      angle.toFixed(1).toString() + "°"
    );

    let record = {
      type: "angle",
      data: angle,
      distance: angle,
      line: res.line,
      visible: true,
      text: [text],
      name: "角度测量" + this.measureRecord.length,
      id: text.uuid,
      point: [this.points[0], this.points[1], this.points[2]],
    };
    this.measureRecord.push(record);

    if (this.updateMeasureRecordCB)
      this.updateMeasureRecordCB(this.getRecords());

    record.line = record.line.concat(this.lines);
    this.lines = [];

    this.points = [];
  }

  /**
   * 测量角度时绘制角度标志
   */
  _drawAngleIcon(pos1, pos2, pos3) {
    let dir1 = pos1.clone().sub(pos2).normalize();
    let dir2 = pos3.clone().sub(pos2).normalize();
    let length1 = pos1.clone().distanceTo(pos2);
    let length2 = pos3.clone().distanceTo(pos2);
    let normal = dir1.clone().cross(dir2).normalize();

    let len = Math.min(length1, length2) / 2.5;

    let angle = dir1.angleTo(dir2);
    //angle = angle/10; // 弧度转角度

    var geometry = new CircleGeometry(len, 32, 0, angle);
    var material = new MeshBasicMaterial({
      color: 0xffff00,
      wireframe: true,
      side: DoubleSide,
      depthTest: false,
    });
    var circle = new Mesh(geometry, material);
    circle.position.copy(pos2);
    circle.lookAt(pos2.clone().add(normal.clone().multiplyScalar(2)));
    circle.updateMatrixWorld();

    const posArray = geometry.attributes.position;
    let p1 = new Vector3(posArray.getX(1), posArray.getY(1), posArray.getZ(1));

    let cameraDir = this.camera.getWorldDirection(new Vector3());
    let firstPoint = circle.localToWorld(p1.clone());
    let circleFirstDir = firstPoint.clone().sub(pos2).normalize();
    let rad = dir1.angleTo(circleFirstDir);
    while (rad > 0.01) {
      if (normal.clone().dot(cameraDir) < 0) circle.rotateZ(-rad);
      else circle.rotateZ(rad);
      circle.updateMatrixWorld();

      firstPoint = circle.localToWorld(p1.clone());
      circleFirstDir = firstPoint.clone().sub(pos2).normalize();
      rad = dir1.angleTo(circleFirstDir);
    }
    circle.updateMatrixWorld();

    let points = [];
    for (var i = 1; i < posArray.count; i++) {
      let p = circle.localToWorld(
        new Vector3(posArray.getX(i), posArray.getY(i), posArray.getZ(i))
      );
      points.push(p);
    }

    const pointsArray = [];
    for (var i = 0; i < points.length; i++) {
      pointsArray.push(points[i].x, points[i].y, points[i].z);
    }

    var lineGeo = new BufferGeometry();
    var lineMat = new LineBasicMaterial({
      color: this.helpLineColor,
      depthTest: false,
      transparent: true,
    });

    lineGeo.setAttribute(
      "position",
      new BufferAttribute(new Float32Array(pointsArray), 3)
    );
    let line = new Line(lineGeo, lineMat);
    this.scene.add(line);
    circle = null;

    //两边生成箭头
    let arrowDir1 = points[1].clone().sub(points[0]).normalize();
    let centerDir1 = arrowDir1.clone().add(dir1).normalize();
    let arrowPos1 = points[0].clone().add(centerDir1.multiplyScalar(len / 6));
    let centerDir2 = arrowDir1.clone().add(dir1.clone().negate()).normalize();
    let arrowPos2 = points[0].clone().add(centerDir2.multiplyScalar(len / 6));
    var arrowGeo1 = new BufferGeometry();
    arrowGeo1.setAttribute(
      "position",
      new BufferAttribute(
        new Float32Array([
          arrowPos1.x,
          arrowPos1.y,
          arrowPos1.z,
          points[0].x,
          points[0].y,
          points[0].z,
          arrowPos2.x,
          arrowPos2.y,
          arrowPos2.z,
        ]),
        3
      )
    );
    let arrow1 = new Line(arrowGeo1, lineMat);
    this.scene.add(arrow1);

    let arrowDir2 = points[points.length - 2]
      .clone()
      .sub(points[points.length - 1])
      .normalize();
    let centerDir3 = arrowDir2.clone().add(dir2).normalize();
    let arrowPos3 = points[points.length - 1]
      .clone()
      .add(centerDir3.multiplyScalar(len / 6));
    let centerDir4 = arrowDir2.clone().add(dir2.clone().negate()).normalize();
    let arrowPos4 = points[points.length - 1]
      .clone()
      .add(centerDir4.multiplyScalar(len / 6));
    var arrowGeo2 = new BufferGeometry();
    arrowGeo2.setAttribute(
      "position",
      new BufferAttribute(
        new Float32Array([
          arrowPos3.x,
          arrowPos3.y,
          arrowPos3.z,
          points[points.length - 1].x,
          points[points.length - 1].y,
          points[points.length - 1].z,
          arrowPos4.x,
          arrowPos4.y,
          arrowPos4.z,
        ]),
        3
      )
    );
    let arrow2 = new Line(arrowGeo2, lineMat);
    this.scene.add(arrow2);

    return {
      pos: points[Math.ceil(points.length / 2)],
      line: [line, arrow1, arrow2],
    };
  }

  /**
   * 弧度转角度
   */
  _deg2rad(angle) {
    return (angle / Math.PI) * 180;
  }

  /**
   * 标高测量
   */
  _measureHeight() {
    let planePos = new Vector3(
      this.points[0].position.x,
      0,
      this.points[0].position.z
    );
    let line = this._drawLine(this.points[0].position, planePos);

    let center = this.points[0].position.clone().add(planePos).divideScalar(2);

    let str = this.getDisStr(this.points[0].position.y * this.scale);

    let text = this._createTextSprite(center, str);

    this.measureRecord.push({
      type: "height",
      line: line,
      visible: true,
      data: this.points[0].position.y * this.scale,
      distance: this._getDis(this.points[0].position.y * this.scale),
      text: [text],
      name: "标高测量" + this.measureRecord.length,
      id: text.uuid,
      point: [this.points[0]],
    });

    if (this.updateMeasureRecordCB)
      this.updateMeasureRecordCB(this.getRecords());

    this.points = [];
  }

  /**
   * 修改测量类型  0：距离测量  1：角度测量  2：标高测量
   * @param {} mode
   */
  setupMeasureMode(mode = 0) {
    if (mode == 1) this.mode = 1;
    else if (mode == 2) this.mode = 2;
    else this.mode = 0;

    if (this.points.length > 0) {
      for (var i = 0; i < this.points.length; i++) {
        this._traverseDispose(this.points[i]);
      }
      this.points = [];
    }
    if (this.lines.length > 0) {
      for (var i = 0; i < this.lines.length; i++) {
        this._traverseDispose(this.lines[i]);
      }
      this.lines = [];
    }

    //this.clear();
  }

  /**
   * 在所给的位置pos创建一个内容为text的文字精灵
   * @param {} pos
   * @param {*} text
   */
  _createTextSprite(pos, text) {
    let textobj = this._createText(text, this.textSize, this.textColor);
    let p = new Object3D();
    this.scene.add(p);
    p.position.copy(pos);
    p.add(textobj);
    return p;
  }

  /**
   * 创建3D文字
   * @param {*} message
   * @param {*} height
   * @param {*} color
   * @param {*} font
   * @param {*} cb
   * @param {*} outlineWidth
   * @returns
   */
  _createText(
    message,
    height,
    color = "#ffffff",
    font = "normal",
    cb,
    outlineWidth = 0.001,
    outlineColor
  ) {
    // 如果要修改Text的shader，需要修改Text.material.baseMaterial，这个属性就是MeshBasicMaterial，修改Text.material无效
    const myText = new Text();
    // Set properties to configure:
    myText.font = "/assets/HONORSansCN-Light.ttf";
    myText.text = message;
    myText.fontSize = height;
    myText.color = color;
    if (font == "bold") {
      myText.outlineWidth = outlineWidth;
      myText.outlineColor = color;
    }
    if (outlineColor) {
      myText.outlineWidth = outlineWidth;
      myText.outlineColor = outlineColor;
    }

    myText.textAlign = "left";
    if (Array.isArray(myText.material)) {
      myText.material[1].baseMaterial.depthTest = false;
      myText._baseMaterial = myText.material[1].baseMaterial;
    } else {
      myText.material.baseMaterial.depthTest = false;
      myText._baseMaterial = myText.material.baseMaterial;
    }

    //回调事件，当异步更新完成后会调用
    myText.sync(() => {
      let size = myText.geometry.boundingBox.getSize(new Vector3());
      myText._width = size.x;
      myText._height = size.y;
      myText.position.x -= size.x / 2;
      myText.position.y += size.y / 2;
      myText.position.z += 0.001;
      if (cb) cb(myText);
    });

    return myText;
  }

  /**
   * 根据所给的两个参数绘制一条直线
   * @param {*} pos1
   * @param {*} pos2
   */
  _drawLine(pos1, pos2) {
    let material = new LineBasicMaterial({
      depthTest: true,
      transparent: true,
    });
    material.color = new Color(this.helpLineColor);

    let geometry = new BufferGeometry();
    geometry.setAttribute(
      "position",
      new BufferAttribute(
        new Float32Array([pos1.x, pos1.y, pos1.z, pos2.x, pos2.y, pos2.z]),
        3
      )
    );
    // geometry.vertices.push(pos1.clone(), pos2.clone());

    let line = new Line(geometry, material);
    line.renderOrder = 999;
    this.scene.add(line);
    return line;
  }

  /**
   * 根据所有位置创建一个辅助球
   * @param {} pos
   */
  _createSphere(pos) {
    let geo = new SphereGeometry(this.helpSphereRadius, 32, 32);
    let mat = new MeshStandardMaterial();
    mat.color = new Color(this.helpSphereColor);
    //mat.color.convertSRGBToLinear();
    let s = new Mesh(geo, mat);
    s.position.copy(pos);
    this.scene.add(s);
    return s;
  }

  update() {
    if (this.measureRecord && this.measureRecord.length > 0) {
      for (var i = 0; i < this.measureRecord.length; i++) {
        let record = this.measureRecord[i];
        if (!record.visible) continue;
        if (record.text) {
          const cameraWorldPos = this.camera.getWorldPosition(new Vector3());
          for (var j = 0; j < record.text.length; j++) {
            let text = record.text[j];
            text.lookAt(cameraWorldPos);
          }
        }
      }
    }
  }

  /**
   * 清除所有球、线、文字
   */
  clear() {
    this.removeAllRecords();
    this.scene = null;
    this.camera = null;
  }

  /**
   * 移除所有测量记录
   */
  removeAllRecords(fromHistory = false) {
    // 历史记录
    if (!fromHistory) {
      const state = {
        record: [].concat(this.measureRecord),
        point: [].concat(this.points),
        line: [].concat(this.lines),
      };
      const cmd = new CommonCommand(
        state,
        (arg) => {
          this.measureRecord = arg.record;
          for (var i = 0; i < this.measureRecord.length; i++) {
            this._restoreRecord(this.measureRecord[i]);
          }
          this.points = arg.point;
          this.lines = arg.line;
          if (this.updateMeasureRecordCB)
            this.updateMeasureRecordCB(this.getRecords());
        },
        (arg) => {
          this.removeAllRecords(true);
        }
      );
      this.manager.addHistory(cmd);
    }

    for (var i = 0; i < this.measureRecord.length; i++) {
      this._removeRecord(this.measureRecord[i]);
    }

    this.measureRecord = [];

    if (this.points.length > 0) {
      for (var i = 0; i < this.points.length; i++) {
        //this._traverseDispose(this.points[i]);
        this.scene.remove(this.points[i]);
      }
      this.points = [];
    }
    if (this.lines.length > 0) {
      for (var i = 0; i < this.lines.length; i++) {
        //this._traverseDispose(this.lines[i]);
        this.scene.remove(this.lines[i]);
      }
      this.lines = [];
    }

    if (this.updateMeasureRecordCB)
      this.updateMeasureRecordCB(this.getRecords());
  }

  /**
   * 设置所有记录显示隐藏
   */
  setAllRecordVisible(visible, fromHistory = false) {
    // 历史记录
    if (!fromHistory) {
      const state = {
        oldState: this.allRecordVisible,
        newState: visible,
      };
      const cmd = new CommonCommand(
        state,
        (arg) => {
          this.setAllRecordVisible(arg.oldState, true);
          //  更新前端
          store.dispatch(setMVisible(arg.oldState));
        },
        (arg) => {
          this.setAllRecordVisible(arg.newState, true);
          //  更新前端
          store.dispatch(setMVisible(arg.newState));
        }
      );
      this.manager.addHistory(cmd);
    }

    this.allRecordVisible = visible;
    for (var i = 0; i < this.measureRecord.length; i++) {
      this._setRecordVisible(this.measureRecord[i], visible);
    }

    if (this.updateMeasureRecordCB)
      this.updateMeasureRecordCB(this.getRecords());
  }

  /**
   * 根据索引设置一条测量记录的显示隐藏
   * @param {*} id
   * @param {*} visible
   */
  setRecordVisibleById(id, visible, fromHistory = false) {
    // 历史记录
    if (!fromHistory) {
      const state = {
        id: id,
        visible: visible,
      };
      const cmd = new CommonCommand(
        state,
        (arg) => {
          this.setRecordVisibleById(arg.id, !arg.visible, true);
        },
        (arg) => {
          this.setRecordVisibleById(arg.id, arg.visible, true);
        }
      );
      this.manager.addHistory(cmd);
    }

    for (var i = 0; i < this.measureRecord.length; i++) {
      if (this.measureRecord[i].id == id) {
        this._setRecordVisible(this.measureRecord[i], visible);
        break;
      }
    }

    if (this.updateMeasureRecordCB)
      this.updateMeasureRecordCB(this.getRecords());
  }

  /**
   * 根据id移除一条测量记录
   * @param {*} id
   */
  removeRecordById(id) {
    for (var i = 0; i < this.measureRecord.length; i++) {
      if (this.measureRecord[i].id == id) {
        // 历史记录
        {
          const state = {
            record: this.measureRecord[i],
            index: i,
          };
          const cmd = new CommonCommand(
            state,
            (arg) => {
              this._restoreRecord(arg.record);
              this.measureRecord.splice(arg.index, 0, arg.record);
              if (this.updateMeasureRecordCB)
                this.updateMeasureRecordCB(this.getRecords());
            },
            (arg) => {
              this._removeRecord(arg.record);
              this.measureRecord.splice(arg.index, 1);
              if (this.updateMeasureRecordCB)
                this.updateMeasureRecordCB(this.getRecords());
            }
          );
          this.manager.addHistory(cmd);
        }

        this._removeRecord(this.measureRecord[i]);
        this.measureRecord.splice(i, 1);
        break;
      }
    }

    if (this.updateMeasureRecordCB)
      this.updateMeasureRecordCB(this.getRecords());
  }

  _restoreRecord(record) {
    if (record) {
      if (record.line) {
        for (var i = 0; i < record.line.length; i++) {
          this.scene.add(record.line[i]);
        }
      }
      if (record.text) {
        for (var i = 0; i < record.text.length; i++) {
          this.scene.add(record.text[i]);
        }
      }
      if (record.point) {
        for (var i = 0; i < record.point.length; i++) {
          this.scene.add(record.point[i]);
        }
      }
    }
  }

  /**
   * 设置一条测量记录的显示隐藏
   * @param {*} record
   * @param {*} visible
   */
  _setRecordVisible(record, visible) {
    if (record) {
      record.visible = visible;
      if (record.line) {
        for (var i = 0; i < record.line.length; i++) {
          record.line[i].visible = visible;
        }
      }
      if (record.text) {
        for (var i = 0; i < record.text.length; i++) {
          record.text[i].visible = visible;
        }
      }
      if (record.point) {
        for (var i = 0; i < record.point.length; i++) {
          record.point[i].visible = visible;
        }
      }
    }
  }

  /**
   * 移除一条测量记录
   * @param {*} record
   */
  _removeRecord(record) {
    if (record) {
      if (record.line) {
        for (var i = 0; i < record.line.length; i++) {
          //this._traverseDispose(record.line[i]);
          this.scene.remove(record.line[i]);
        }
      }
      if (record.text) {
        for (var i = 0; i < record.text.length; i++) {
          //this._traverseDispose(record.text[i]);
          this.scene.remove(record.text[i]);
        }
      }
      if (record.point) {
        for (var i = 0; i < record.point.length; i++) {
          //this._traverseDispose(record.point[i]);
          this.scene.remove(record.point[i]);
        }
      }
      //record = null;
    }
  }

  _traverseDispose(obj) {
    if (obj) {
      if (obj.geometry) obj.geometry.dispose();
      if (obj.material) {
        if (Array.isArray(obj.material)) {
          obj.material.forEach((m) => {
            if (m.dispose) m.dispose();
          });
        } else obj.material.dispose();
      }

      if (obj.removeFromParent) obj.removeFromParent();
      if (obj._entity) {
        obj._entity.removeAllComponents(); // Remove all components on this entity.
        obj._entity.remove(); // Remove this entity from the world.
      }

      if (obj.dispose) obj.dispose();

      if (obj.children && obj.children.length > 0) {
        obj.children.forEach((c) => {
          this._traverseDispose(c);
        });
      }
    }
  }

  /**
   * 获取所有测量记录
   * @returns
   */
  getRecords() {
    const res = [];
    for (var i = 0; i < this.measureRecord.length; i++) {
      res.push({
        name: this.measureRecord[i].name,
        id: this.measureRecord[i].id,
        distance: this.measureRecord[i].distance,
        visible: this.measureRecord[i].visible,
        unit: this.unit,
      });
    }
    return res;
  }

  getCurrentDisStrById(id) {
    for (var i = 0; i < this.measureRecord.length; i++) {
      if (this.measureRecord[i].id == id) {
        return this.getDisStr(this.measureRecord[i].data);
      }
    }
    return 0;
  }

  /**
   * 设置通知前端更新UI的回调函数，参数为测量记录，通常在增加测量记录和修改单位后调用
   * @param {*} cb
   */
  setUpdateMeasureRecordCB(cb) {
    this.updateMeasureRecordCB = cb;
  }
}

export { MeasureUtil };
